// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__f9O4Z","text":"footer_text__43VHd"};